module.exports = __webpack_public_path__ + "static/media/drag-and-drop.996aeaf9.svg";